import { Study } from "features/optimization/state/studyAtoms";
import { determinePresetId, ObjectiveKey, OBJECTIVE_PRESETS } from "shared/domain/objectivePresets";
import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchStudyResult = async (
  authToken: string,
  name: string
): Promise<Study | null> => {
  try {
    const { response, data } = await fetchFfdJson<{ body: any; text?: string }>(
      `/studies/result?study_name=${encodeURIComponent(name)}`,
      authToken
    );
    if (response.ok) {
      const objectives: ObjectiveKey[] =
        (data.body?.objectives as ObjectiveKey[] | undefined) ??
        [];

      const presetId = objectives.length
        ? determinePresetId(Object.fromEntries(objectives.map((k) => [k, true])))
        : determinePresetId(data.body?.objective_list || data.body?.cfd_id_list || {});

      const normalizedObjectives =
        objectives.length > 0
          ? objectives
          : OBJECTIVE_PRESETS[presetId].objectives.map((o) => o.key);

      const errorCodeList1 = data.body?.error_code_list?.error_code_list_1;
      return {
        status_code: response.status,
        name: name,
        presetId: data.body?.objective_type,
        objectives: normalizedObjectives,
        objective_list: {
          objective_list_1:
            data.body?.objective_list?.objective_list_1,
          objective_list_2:
            data.body?.objective_list?.objective_list_2
        },
        cfd_id_list: {
          cfd_id_list_1:
            data.body?.cfd_id_list?.cfd_id_list_1,
          cfd_id_list_2:
            data.body?.cfd_id_list?.cfd_id_list_2,
        },
        // API 契約: 多目的でも trial 単位で error_code_list_1 のみ（error_code_list_2 は存在しない）
        error_code_list: Array.isArray(errorCodeList1)
          ? { error_code_list_1: errorCodeList1 }
          : undefined,
        hypervolume_list: data.body?.hypervolume_list,
      } as Study;
    } else {
      if (data.text) alert(data.text);
      return null;
    }
  } catch (error) {
    alertAuthExpired();
    return null;
  }
};
